import React from 'react';
import { Link } from 'react-router-dom';

interface NavigationCardProps {
  title: string;
  description: string;
  route: string;
}

const NavigationCard: React.FC<NavigationCardProps> = ({
  title,
  description,
  route
}) => {
  return (
    <Link to={route} className="card-link">
      <div className="card post-card clickable">
        <div className="card-content">
          <div className="card-header-row">
            <h3 className="card-title">{title}</h3>
            <div className="card-arrow">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M6 4L10 8L6 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <p className="card-description">{description}</p>
        </div>
      </div>
    </Link>
  );
};

export default NavigationCard; 